<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 484 427"
    role="img"
    [attr.aria-label]="ariaLabel"
    [attr.width]="widthPx"
    [attr.height]="heightPx"
    [innerHTML]="paths"
></svg>
